import axios, { AxiosError } from 'axios';

/**
 * Shared HTTP client. In dev `VITE_API_URL` is unset, so the base URL is
 * empty and Vite's proxy forwards `/api/*` to the backend on port 3001
 * (see vite.config.ts). In SST-deployed environments `VITE_API_URL` points
 * at the API custom domain (e.g. https://staff-api.kaerwell.com) and `/api/*`
 * paths land on the Lambda directly.
 *
 * `withCredentials: true` lets the browser send the `kw_session` cookie
 * cross-origin (dev: Vite at :3200 → server at :3001; prod: staff → staff-api).
 */
export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

/** Re-export for callers that need to detect status codes. */
export { AxiosError };
